import api from '@/services/api'

export default {
  state: {
    isLoggedSGOIn: !!localStorage.getItem('tokenSGO'),
    userSGO: {
      codUsuario: '',
      codColigada: '',
      nomeColigada: '',
      isAdmin: false,
    },
  },

  mutations: {
    AUTH(state, user) {
      state.isLoggedSGOIn = true
      state.userSGO = {
        codUsuario: user.codUsuario,
        codColigada: user.codColigada,
        nomeColigada: user.nomeColigada,
        isAdmin: user.isAdmin,
      }
    },

    LOGOUT(state) {
      state.isLoggedSGOIn = false
      state.userSGO = {
        codUsuario: '',
        codColigada: '',
        nomeColigada: '',
        isAdmin: false,
      }
    },
  },

  actions: {
    async auth({ commit }, credentials) {
      try {
        const response = await api.post('/auth', {
          codUsuario: credentials.codUsuario,
          password: credentials.password,
          codColigada: credentials.codColigada,
        })

        const data = response && response.data ? response.data : null
        const token = data && data.token ? data.token : ''

        const user = {
          codUsuario: data && data.user ? data.user.codUsuario : '',
          codColigada: data && data.user ? data.user.codColigada : '',
          nomeColigada: data && data.user ? data.user.nomeColigada : '',
          isAdmin: data && data.user ? data.user.isAdmin : false,
        }

        localStorage.setItem('tokenSGO', token)
        commit('AUTH', user)
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    async changeColigada({ commit }, credentials) {
      try {
        const response = await api.post('/auth/set-empresa', {
          codColigada: credentials.codColigada,
        })

        const data = response && response.data ? response.data : null
        const token = data && data.token ? data.token : ''

        const user = {
          codUsuario: data && data.user ? data.user.codUsuario : '',
          codColigada: data && data.user ? data.user.codColigada : '',
          nomeColigada: data && data.user ? data.user.nomeColigada : '',
          isAdmin: data && data.user ? data.user.isAdmin : false,
        }

        localStorage.setItem('tokenSGO', token)
        commit('AUTH', user)
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    logout: ({ commit }) => {
      commit('LOGOUT')
    },
  },

  getters: {
    isLoggedSGOIn: (state) => state.isLoggedSGOIn,
    user: (state) => state.userSGO,
  },
}
